import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles, withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import clsx from 'clsx'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flex: 1,
    },
    rounded: {
      '& .MuiLinearProgress-root': {
        height: 15,
        borderRadius: 7.5,
      },
    },
  }),
)

interface IProps {
  value: number
  className?: string
  variant?: 'default' | 'rounded'
  barColor?: string
}

const CustomizedLinearProgress: FC<IProps> = ({
  value,
  className,
  variant,
  barColor = '#00A193',
}) => {
  const classes = useStyles()

  if (typeof value === 'undefined') {
    return null
  }

  const DynamicBorderLinearProgress = withStyles((theme: ITheme) =>
    createStyles({
      root: {
        height: 16,
        borderRadius: 4,
        backgroundColor: theme.palette.grey[200],
      },
      bar: {
        borderRadius: 4,
        backgroundColor: barColor,
      },
    }),
  )(LinearProgress)

  return (
    <div
      className={clsx(
        classes.root,
        variant === 'rounded' && classes.rounded,
        className,
      )}
    >
      <DynamicBorderLinearProgress variant="determinate" value={value} />
    </div>
  )
}

export default CustomizedLinearProgress
